import * as React from 'react'
import styled from 'style/styled-components'
import Theme from 'style/theme'
import { ThemeProps } from 'styled-components'

const StyledChip = styled.span`
  background: ${(props: ThemeProps<Theme>): string => props.theme.chip.background};
  border-radius: 3px;
  padding: 2px 6px;
  font-size: .75em;
`

const Chip = (props: React.HTMLAttributes<HTMLSpanElement>): JSX.Element => (
  <StyledChip {...props} />
)

export default Chip



// WEBPACK FOOTER //
// ./src/components/_atoms/chip.tsx